import config from '../config';
import Service from '@jobstairs/keycloak-token-service';
import { get } from 'lodash';
import { decodeJwt } from 'jose';

const ROLES_PATH = 'resource_access.jobstairs_tools.roles';
const USER_ROLE = 'betterads_user';
const SUPER_USER_ROLE = 'betterads_super_user';
const FREETEXT_USER = 'betterads_freetext_analysis';
const BEESITE_USER = 'betterads_beesite_user';

export class TokenService extends Service {
    constructor({ clientId, scope, baseURL, endpoint }) {
        super({ clientId, scope, baseURL, endpoint });
    }

    getDecodedToken() {
        const token = this.getAccessToken();
        // Check if token exists and is a valid string before decoding
        if (!token || typeof token !== 'string') {
            return {};
        }
        return decodeJwt(token);
    }

    getEmail() {
        return this.getDecodedToken().email;
    }

    getRoles() {
        return get(this.getDecodedToken(), ROLES_PATH, []);
    }

    hasParentOrganization() {
        return this.getParentOrganization() !== undefined;
    }

    getParentOrganization() {
        return this.getDecodedToken()?.parent_organization;
    }

    isUser() {
        return this.getRoles().includes(USER_ROLE);
    }

    isSuperUser() {
        return this.getRoles().includes(SUPER_USER_ROLE);
    }

    isFreetextUser() {
        return this.getRoles().includes(FREETEXT_USER);
    }
    isBeesiteUser() {
        return this.getRoles().includes(BEESITE_USER);
    }
}

export default (() => {
    return new TokenService({
        clientId: config.tokenService.clientId,
        scope: config.tokenService.scope,
        baseURL: config.tokenService.baseURL,
        endpoint: config.tokenService.endpoint,
    });
})();
